import { HomeLocationAutocompleteContainer } from '@/containers/HomeLocationAutocompleteContainer';
import { Icon } from '@eventbrite/legacy-eds.icon';
import { ChevronDownChunky } from '@eventbrite/legacy-eds.iconography';
import { FormattedMessage } from 'react-intl';
import type { Location } from '@/types';
import styles from './BrowseEventsInLocationSelector.module.scss';

const Chevron = <Icon type={<ChevronDownChunky />} color="ui-blue--hover" size="medium" />;
const LOCATION_AUTOCOMPLETE_PROPS = {
    prefix: Chevron,
    borderType: 'content',
    id: 'locationPicker',
    name: 'locationPicker',
    hideOutline: true,
    isLimitedSearch: true,
    preventInputValuePrefill: true,
    shouldRemoveConflictiveAria: true,
};

export const BrowseEventsInLocationSelector = ({ location }: { location?: Location }) => {
    return (
        <div className={styles.location}>
            <h1 className={styles.locationText}>
                <FormattedMessage id="Browsing events in " defaultMessage="Browsing events in " />
            </h1>
            <HomeLocationAutocompleteContainer
                autocompleteProps={LOCATION_AUTOCOMPLETE_PROPS}
                shouldDispatchSearchActions={true}
                location={location}
            />
        </div>
    );
};
